/*
 * @description: 提示信息
 */
import HintOutline from '@imgs/icons/hint-outline.svg';
import styles from './index.less';

type BannerTipProps = {
  tip: string; // 提示文案
  style?: React.CSSProperties;
  children?: React.ReactNode;
  iconWidth?: number;
  iconStyle?: React.CSSProperties;
  icon?: React.ReactNode;
  showIcon?: boolean;
};
export default ({
  tip,
  children,
  style: propsStyle,
  iconWidth,
  iconStyle,
  icon,
  showIcon = true,
}: BannerTipProps) => {
  return (
    <div style={propsStyle} className={styles['banner-wrapper']}>
      {showIcon &&
        (icon || (
          <HintOutline
            className={styles['hint-icon']}
            width={iconWidth || 20}
            height={iconWidth || 20}
            style={iconStyle}
          />
        ))}
      <span className={styles.content}>
        {tip}
        {children}
      </span>
    </div>
  );
};
